import BaseMixin from "BaseMixin"
import Organization from "Models/Organization"
import PageMixin from "../../../mixins/PageMixin"
import template from "./OrganizationIntegrations.html"
import AdministratorMixin from "../../../mixins/AdministratorMixin"

export default {
  // routes(prefix: string): Array<any> {
  //   return [{
  //     path: `/${prefix}/admin/organizations/integrations/:id`,
  //     title: 'app-organization-integrations'
  //   }]
  // },
  
  mixins: [AdministratorMixin, BaseMixin, PageMixin],
  
  template: template,

  data() {
    return {
      fields: [
        { title: 'Name', name: 'name' },
        { title: '', name: 'value-slot' }
      ],
      organization: new Organization(),
      showAddContactAsAdmin: false,
      currentLanguage: 'en',
      tableData: {}
    }
  },

  async mounted() {
    this.app.showLoading()
    if(this.$route?.params.id) {
      this.app.showLoading()
      this.organization.document.id = this.$route.params.id
      await this.organization.load()
    }
    this.ready()
  },

  methods: {
    async save() {
      this.app.showLoading()
      await this.organization.save()
      this.router.push(this.link(`admin/organizations`))
    }
  }
  
}
